import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { Currency } from "@/gql/graphql";

const CURRENCY_LABELS: Record<Currency, string> = {
  [Currency.Aud]: "AUD",
  [Currency.Nzd]: "NZD",
  [Currency.Cad]: "CAD",
  [Currency.Eur]: "EUR",
  [Currency.Dkk]: "DKK",
  [Currency.Sek]: "SEK",
  [Currency.Nok]: "NOK",
  [Currency.Gbp]: "GBP",
  [Currency.Usd]: "USD",
  [Currency.Idr]: "IDR",
  [Currency.Pgk]: "PGK",
  [Currency.Sbd]: "SBD",
  [Currency.Vuv]: "VUV",
  [Currency.Xpf]: "XPF",
  [Currency.Fjd]: "FJD",
  [Currency.Jpy]: "JPY",
  [Currency.Zar]: "ZAR",
  [Currency.Twd]: "NTD", // The iso code is different to the name
  [Currency.Brl]: "BRL",
  [Currency.Clp]: "CLP",
  [Currency.Ars]: "ARS",
  [Currency.Aed]: "AED",
  [Currency.Mxn]: "MXN",
  [Currency.Krw]: "KRW",
};

export function currencyLabel(value?: Currency | null): string | undefined {
  return value ? CURRENCY_LABELS[value] : undefined;
}

export function CurrencyTypeInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  const options = Object.fromEntries(
    (Object.entries(CURRENCY_LABELS) as [Currency, string][]).map(
      ([value, label]) => [value, { label, value }],
    ),
  ) as Record<Currency, { label: string; value: Currency }>;

  const allOptions = [
    {
      label: "Oceania",
      options: [options[Currency.Aud], options[Currency.Nzd]],
    },
    {
      label: "North America",
      options: [options[Currency.Cad], options[Currency.Usd]],
    },
    {
      label: "Europe",
      options: [
        options[Currency.Eur],
        options[Currency.Gbp],
        options[Currency.Nok],
        options[Currency.Dkk],
        options[Currency.Sek],
      ],
    },
    {
      label: "Asia",
      options: [
        options[Currency.Jpy],
        options[Currency.Twd],
        options[Currency.Krw],
      ],
    },
    {
      label: "Middle East",
      options: [options[Currency.Aed]],
    },
    {
      label: "Latin America",
      options: [
        options[Currency.Brl],
        options[Currency.Clp],
        options[Currency.Ars],
        options[Currency.Mxn],
      ],
    },
    {
      label: "Africa",
      options: [options[Currency.Zar]],
    },
    {
      label: "Pacific Islands",
      options: [
        options[Currency.Fjd],
        options[Currency.Idr],
        options[Currency.Xpf],
        options[Currency.Pgk],
        options[Currency.Sbd],
        options[Currency.Vuv],
      ],
    },
  ];

  const flatOptions = allOptions.flatMap((group) => group.options);

  return (
    <SelectInput
      options={allOptions}
      filter={(value, search) => {
        const option = flatOptions.find((opt) => opt.value === value);
        if (!option) return 0;
        return option.label.toLowerCase().includes(search.toLowerCase())
          ? 1
          : 0;
      }}
      {...props}
    />
  );
}
